export default __webpack_public_path__ + "static/media/tips_packaging.dd8af70d.png";